"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    hugVariants: ()=>hugVariants,
    hugPalettes: ()=>hugPalettes,
    hugEmphasis: ()=>hugEmphasis,
    hugAnimations: ()=>hugAnimations
});
const tv_cjs_namespaceObject = require("../../variants/tv.cjs");
const hugSlots = {
    hugContainerSlot: 'flex flex-col rounded-xl border-1',
    headingSlot: 'flex flex-row items-center gap-3 p-3',
    headingWrapperSlot: 'flex flex-col gap-1',
    iconSlot: 'bg-primary-1 flex items-center justify-center rounded-full p-3',
    badgeSlot: 'w-fit',
    animationWrapperSlot: '',
    animationWrapperSlotLoop: ''
};
const hugPaletteVariants = {
    neutral: '',
    primary: ''
};
const hugEmphasisVariants = {
    regular: {
        hugContainerSlot: 'bg-neutral-1 border-primary-2'
    },
    medium: '',
    bold: ''
};
const hugAnimationWrapperStyles = 'relative mx-auto overflow-hidden rounded-[18px] p-[2px] transition-all duration-200 ease-in-out before:absolute before:-inset-[300px] before:-z-10 before:rounded-[800px] before:bg-[conic-gradient(from_0deg,var(--color-penny-14),var(--color-primary-8),var(--color-primary-9),var(--color-penny-14))]';
const hugAnimationVariants = {
    borderGradientSpinLoop: {
        animationWrapperSlotLoop: `before:animate-gradient-spin ${hugAnimationWrapperStyles}`
    },
    borderGradientSpinSingle: {
        animationWrapperSlot: `before:animate-gradient-spin-slide-in ${hugAnimationWrapperStyles}`
    }
};
const isEmphasisAndPaletteCompoundVariants = [
    {
        palette: 'neutral',
        emphasis: 'regular',
        class: {
            iconSlot: 'bg-neutral-3'
        }
    },
    {
        palette: 'neutral',
        emphasis: 'medium',
        class: {
            hugContainerSlot: 'bg-neutral-3 border-neutral-3',
            iconSlot: 'bg-neutral-1/90'
        }
    },
    {
        palette: 'neutral',
        emphasis: 'bold',
        class: {
            hugContainerSlot: 'bg-neutral-12 border-neutral-12'
        }
    },
    {
        palette: 'primary',
        emphasis: 'regular',
        class: {
            iconSlot: 'bg-primary-3'
        }
    },
    {
        palette: 'primary',
        emphasis: 'medium',
        class: {
            hugContainerSlot: 'bg-primary-3 border-primary-3',
            iconSlot: 'bg-primary-1/90'
        }
    },
    {
        palette: 'primary',
        emphasis: 'bold',
        class: {
            hugContainerSlot: 'bg-primary-8 border-primary-8'
        }
    }
];
const hugDefaultVariants = {
    palette: 'primary',
    emphasis: 'regular'
};
const hugPalettes = Object.keys(hugPaletteVariants);
const hugEmphasis = Object.keys(hugEmphasisVariants);
const hugAnimations = Object.keys(hugAnimationVariants);
const hugVariants = (0, tv_cjs_namespaceObject.tv)({
    slots: hugSlots,
    variants: {
        palette: hugPaletteVariants,
        emphasis: hugEmphasisVariants,
        animation: hugAnimationVariants
    },
    defaultVariants: hugDefaultVariants,
    compoundVariants: isEmphasisAndPaletteCompoundVariants
});
exports.hugAnimations = __webpack_exports__.hugAnimations;
exports.hugEmphasis = __webpack_exports__.hugEmphasis;
exports.hugPalettes = __webpack_exports__.hugPalettes;
exports.hugVariants = __webpack_exports__.hugVariants;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "hugAnimations",
    "hugEmphasis",
    "hugPalettes",
    "hugVariants"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
